import { type ReviewPromptGuideViewContent } from "./ReviewPromptGuideView";

interface KnockReviewPromptContent {
  title?: string;
  body?: string;
  yesButtonText?: string;
  noButtonText?: string;
  laterButtonText?: string;
  feedbackTitle?: string;
  feedbackBody?: string;
  feedbackPlaceholder?: string;
  feedbackSubmitText?: string;
  feedbackSupportText?: string;
  feedbackCancelText?: string;
  appreciationTitle?: string;
  appreciationBody?: string;
}

function trimString(value: unknown): string | undefined {
  if (typeof value !== "string") {
    return undefined;
  }

  const trimmed = value.trim();
  return trimmed === "" ? undefined : trimmed;
}

export function normalizeContent(content: unknown): ReviewPromptGuideViewContent | undefined {
  if (typeof content !== "object" || content === null) {
    return undefined;
  }

  const raw = content as KnockReviewPromptContent;

  const title = trimString(raw.title);
  const yesButtonText = trimString(raw.yesButtonText);
  const noButtonText = trimString(raw.noButtonText);
  const laterButtonText = trimString(raw.laterButtonText);

  // noButtonText is optional: production omits it to remove the No/feedback
  // action, so it must not gate the guide from rendering.
  if (!title || !yesButtonText || !laterButtonText) {
    return undefined;
  }

  return {
    title,
    body: trimString(raw.body),
    yesButtonText,
    noButtonText,
    laterButtonText,
    feedbackTitle: trimString(raw.feedbackTitle),
    feedbackBody: trimString(raw.feedbackBody),
    feedbackPlaceholder: trimString(raw.feedbackPlaceholder),
    feedbackSubmitText: trimString(raw.feedbackSubmitText),
    feedbackSupportText: trimString(raw.feedbackSupportText),
    feedbackCancelText: trimString(raw.feedbackCancelText),
    appreciationTitle: trimString(raw.appreciationTitle),
    appreciationBody: trimString(raw.appreciationBody),
  };
}
